import React from 'react'

import logoImage from './components/logo.png'
import logIn from '../../actions/logIn'
import GameHistory from './components/GameHistory'
import {
  Page,
  Logo,
  Button,
  ButtonLink,
  ButtonPair,
  FixedAction,
  Video,
} from '../styles'

const Lobby = (props) => (
  <Page>
    <Logo src={logoImage} />
    <p>A real-life game for friends and frienemies</p>
      {/*
      <p>Assassinate other players by tricking them into saying a secret word.</p>
      <p>If you say your assassin's secret word, you're dead.</p>
      <p>Last one standing wins!</p>
      */}

      <Video controls="true">
        <source src="sanc_mpf89_monroe_color_a.mp4" type='video/mp4; codecs="avc1.4D401E, mp4a.40.2"' />
      </Video>

      {props.auth ? <GameHistory userId={props.auth.uid} /> : null}

      <FixedAction>
        {props.auth ?
          <ButtonPair>
            <ButtonLink primary="true" to="/new">New game</ButtonLink>
            <ButtonLink to="/join">Join game</ButtonLink>
          </ButtonPair>
          :
          <Button primary onClick={logIn}>Log in with Google</Button>
        }
      </FixedAction>
    </Page>
)

export default Lobby



// WEBPACK FOOTER //
// ./src/views/lobby/Lobby.jsx